// src/data/seamsiData.js

export const seamsiFortunes = [
  {
    id: 1,
    number: "๑",
    title: "หมายเลข ๑",
    text: "โชคดี",
    desc: "รับของไปเลยจ้า วันนี้โชคดีสุดๆ ไปเลย",
    luckyColor: "สีเขียว",
  },
  {
    id: 2,
    number: "๒",
    title: "หมายเลข ๒",
    text: "เกลือ",
    desc: "อดจ้า โอกาสหน้าค่อยมาใหม่",
    luckyColor: "สีชมพู",
  }
];